import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './module.not-found.css';

const destinations = [
  { number: '01', title: 'Explore our services', description: 'Expert estimating for your next build.', to: '/general-contractor' },
  { number: '02', title: 'Meet Surya Group', description: 'The people behind the precision.', to: '/about' },
  { number: '03', title: 'Let’s talk', description: 'Find the right support for your project.', to: '/contact-us' },
];

function Arrow({ back = false }) {
  return <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none"><path d={back ? 'M19 12H5m6-6-6 6 6 6' : 'M5 12h14m-6-6 6 6-6 6'} stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" /></svg>;
}

const NotFound = () => {
  const navigate = useNavigate();
  const handleGoBack = () => {
    // Direct visits may have no previous entry within this application.
    if (window.history.state?.idx > 0) navigate(-1);
    else navigate('/', { replace: true });
  };

  return (
    <div className="sg-not-found">
      <div className="sg-nf-container">
        <nav className="sg-nf-breadcrumb" aria-label="Breadcrumb">
          <Link to="/">Home</Link><span aria-hidden="true">/</span><span aria-current="page">Page not found</span>
        </nav>

        <div className="sg-nf-hero">
          <div className="sg-nf-copy">
            <p className="sg-nf-eyebrow"><span /> A SMALL DETOUR</p>
            <h1>This page isn’t<br />in the <em>plans.</em></h1>
            <p className="sg-nf-description">Even the best projects take a wrong turn. The page you’re looking for may have moved, or the link may be incorrect. Let’s get you back on track.</p>
            <div className="sg-nf-actions">
              <Link className="sg-nf-home" to="/">Back to homepage <Arrow /></Link>
              <button className="sg-nf-back" type="button" onClick={handleGoBack}><Arrow back /> Go back</button>
            </div>
            <p className="sg-nf-help">Looking for something specific? <Link to="/contact-us">We’re here to help <span aria-hidden="true">↗</span></Link></p>
          </div>

          <div className="sg-nf-blueprint" aria-hidden="true">
            <div className="sg-nf-sheet-top"><span>SURYA GROUP / BLUEPRINT SERIES</span><span>NO. 404</span></div>
            <div className="sg-nf-drawing">
              <div className="sg-nf-dimension"><span /> A LITTLE OFF THE GRID <span /></div>
              <div className="sg-nf-code">4<span>0</span>4</div>
              <svg className="sg-nf-route" viewBox="0 0 400 110" fill="none">
                <path d="M20 80h100V30h125v50h130" stroke="currentColor" strokeWidth="1.5" strokeDasharray="5 6" />
                <circle cx="20" cy="80" r="5" fill="currentColor" />
                <circle cx="375" cy="80" r="9" stroke="currentColor" strokeWidth="1.5" />
                <circle cx="375" cy="80" r="3" fill="currentColor" />
              </svg>
              <span className="sg-nf-location">YOU ARE HERE. WE’LL TAKE IT FROM HERE.</span>
            </div>
            <div className="sg-nf-sheet-bottom"><div><span>STATUS</span><strong>Page not found</strong></div><div className="sg-nf-stamp">LET’S REBUILD<br />YOUR ROUTE <span>↗</span></div></div>
            <span className="sg-nf-cross sg-nf-cross-one">+</span><span className="sg-nf-cross sg-nf-cross-two">+</span>
          </div>
        </div>

        <div className="sg-nf-explore">
          <div className="sg-nf-explore-heading"><h2>A good place to start.</h2><span>YOUR NEXT STEP</span></div>
          <div className="sg-nf-links">
            {destinations.map(({ number, title, description, to }) => (
              <Link key={to} className="sg-nf-card" to={to}>
                <span className="sg-nf-card-number">{number}</span>
                <div><h3>{title}</h3><p>{description}</p></div>
                <span className="sg-nf-card-arrow" aria-hidden="true">↗</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
